"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var asg_1 = require("@alinta-digital/asg");
var formik_1 = require("formik");
var icons_1 = require("@alinta-digital/asg/icons");
var config_1 = require("./config");
var CreditCardFields_1 = tslib_1.__importDefault(require("./CreditCardFields"));
var CreditCardImage_1 = tslib_1.__importDefault(require("./CreditCardImage"));
var CVVImages_1 = require("./CVVImages");
var types_1 = require("../../types");
var CreditCards = function (props) {
    var sectionKey = props.sectionKey, instance = props.instance, onError = props.onError, onComplete = props.onComplete, disabled = props.disabled;
    var _a = react_1.useState(''), cardNumberError = _a[0], setCardNumberError = _a[1];
    var _b = react_1.useState(''), expiryError = _b[0], setExpiryError = _b[1];
    var _c = react_1.useState(''), cvvError = _c[0], setCVVError = _c[1];
    var _d = react_1.useState(false), isCardNumberComplete = _d[0], setIsCardNumberComplete = _d[1];
    var _e = react_1.useState(false), isExpiryComplete = _e[0], setIsExpiryComplete = _e[1];
    var _f = react_1.useState(false), isCVVComplete = _f[0], setIsCVVComplete = _f[1];
    var _g = react_1.useState(types_1.PaymentCardType.EMPTY), cardType = _g[0], setCardType = _g[1];
    var _h = react_1.useState(''), fieldFocus = _h[0], setFieldFocus = _h[1];
    react_1.useEffect(function () {
        if (isCardNumberComplete && isExpiryComplete && isCVVComplete)
            onComplete(cardType);
        else
            onError();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCardNumberComplete, isExpiryComplete, isCVVComplete]);
    react_1.useEffect(function () {
        instance.create(types_1.CCFieldType.CardNumber, config_1.cardNumber.options).mount("#" + config_1.cardNumber.elementId);
        instance.create(types_1.CCFieldType.Cvv, config_1.cvv.options).mount("#" + config_1.cvv.elementId);
        instance.create(types_1.CCFieldType.Expiry, config_1.expiry.options).mount("#" + config_1.expiry.elementId);
        instance.on('error', function (event) {
            var message = event.message || 'error';
            if (event.field === types_1.CCFieldType.CardNumber) {
                setCardNumberError(message);
                setIsCardNumberComplete(false);
            }
            else if (event.field === types_1.CCFieldType.Cvv) {
                setCVVError(message);
                setIsCVVComplete(false);
            }
            else if (event.field === types_1.CCFieldType.Expiry) {
                setExpiryError(message);
                setIsExpiryComplete(false);
            }
        });
        instance.on('complete', function (event) {
            if (event.field === types_1.CCFieldType.CardNumber) {
                setCardNumberError('');
                setIsCardNumberComplete(true);
            }
            else if (event.field === types_1.CCFieldType.Cvv) {
                setCVVError('');
                setIsCVVComplete(true);
            }
            else if (event.field === types_1.CCFieldType.Expiry) {
                setExpiryError('');
                setIsExpiryComplete(true);
            }
        });
        instance.on('focus', function (event) {
            setFieldFocus(event.field);
        });
        instance.on('blur', function () {
            setFieldFocus('');
        });
        instance.on('brand', function (event) {
            var brand = event.brand || types_1.PaymentCardType.EMPTY;
            setCardType(brand);
        });
    }, [instance]);
    return (react_1.default.createElement(asg_1.Box, null,
        react_1.default.createElement(CreditCardImage_1.default, { cardType: cardType }),
        react_1.default.createElement(asg_1.Box, { margin: { bottom: 'small' } },
            react_1.default.createElement(CreditCardFields_1.default, { label: "Card number", elementId: config_1.cardNumber.elementId, error: cardNumberError.length > 0, errorMessage: cardNumberError, focus: fieldFocus === types_1.CCFieldType.CardNumber, maxWidth: "704px !important" })),
        react_1.default.createElement(asg_1.Box, { margin: { bottom: 'small' } },
            react_1.default.createElement(formik_1.Field, { name: sectionKey + ".cardName", id: sectionKey + ".cardName", "data-testid": sectionKey + "-cardName", label: "Name on card", placeholder: "Cardholder name", ariaRequired: true, disabled: disabled, component: asg_1.FormTextInput })),
        react_1.default.createElement(asg_1.FlexGrid, null,
            react_1.default.createElement(asg_1.FlexGridItem, { xs: 6 },
                react_1.default.createElement(CreditCardFields_1.default, { label: "Expiry", elementId: config_1.expiry.elementId, error: expiryError.length > 0, errorMessage: expiryError, focus: fieldFocus === types_1.CCFieldType.Expiry })),
            react_1.default.createElement(asg_1.FlexGridItem, { xs: 6 },
                react_1.default.createElement(CreditCardFields_1.default, { label: "CVV", icon: react_1.default.createElement(asg_1.Tooltip, { content: react_1.default.createElement(asg_1.Box, { direction: "column", margin: { bottom: 'xsmall' } },
                            react_1.default.createElement(CVVImages_1.VisaMasterCVV, null),
                            react_1.default.createElement(CVVImages_1.AmexCVV, null)), openOnClick: true, openOnFocus: true, openOnHover: true, ariaLabel: "Customer reference number", maxWidth: 300 },
                        react_1.default.createElement(asg_1.Icon, { icon: icons_1.Info, id: "tooltip", width: "20px", height: "20px", css: { padding: '0 !important' }, fill: asg_1.colors['primaryBlue-1'] })), elementId: config_1.cvv.elementId, error: cvvError.length > 0, errorMessage: cvvError, focus: fieldFocus === types_1.CCFieldType.Cvv })))));
};
exports.default = CreditCards;
//# sourceMappingURL=CreditCard.js.map